import { CmsPageAppearanceSettings } from "@/components/cms/theme/CmsPageAppearanceSettings";
import StyledDrawer from "@/components/StyledDrawer";
import { Button } from "@/components/ui/button";
import { CustomDialogFooter } from "@/components/ui/custom-dialog";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useCmsPageAppearance } from "@/context/cms/CmsPageAppearanceContext";
import { useToast } from "@/hooks/use-toast";
import { beginDrawerAppearanceSave } from "@/lib/cms/cms-page-appearance-drawer-save";
import { useTranslation } from "react-i18next";

const LOGIN_SIGNUP_FORM_ID = "login-signup";

export function CmsPageAppearanceDrawer() {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { open, setOpen, formId, formPrefix, setFormPrefix, saveHandlers } =
    useCmsPageAppearance();

  if (!formId) return null;

  const showLoginSignupSwitcher = formId === LOGIN_SIGNUP_FORM_ID;
  const activePrefix = formPrefix ?? "login";

  const handleSave = () => {
    beginDrawerAppearanceSave();

    if (saveHandlers?.submitAll) {
      saveHandlers.submitAll();
    } else {
      const formElement = document.getElementById(formId);
      if (formElement instanceof HTMLFormElement) {
        if (typeof formElement.requestSubmit === "function") {
          formElement.requestSubmit();
        } else {
          formElement.submit();
        }
      } else {
        toast({
          title: t("error"),
          description: t("cms.appearance.error.save"),
          variant: "error",
          duration: 3000,
        });
        return;
      }
    }
    setOpen(false);
  };

  return (
    <StyledDrawer
      sheetProps={{ open, onOpenChange: setOpen }}
      title={t("cms.page.appearance.drawerTitle")}
      maxWidth="sm:max-w-md"
      hideSeparator={false}
      keepContentMounted
      footer={
        <CustomDialogFooter className="w-full">
          <Button
            type="button"
            className="w-full font-semibold"
            disabled={saveHandlers?.isSaveDisabled ?? false}
            onClick={handleSave}
          >
            {t("cmsEnregistrerBouton")}
          </Button>
        </CustomDialogFooter>
      }
    >
      {showLoginSignupSwitcher && (
        <Tabs
          value={activePrefix}
          onValueChange={(value) =>
            setFormPrefix(value === "signup" ? "signup" : "login")
          }
          className="mb-4 w-full"
        >
          <TabsList className="w-full">
            <TabsTrigger value="login" className="flex-1">
              {t("cms.page.appearance.loginTab")}
            </TabsTrigger>
            <TabsTrigger value="signup" className="flex-1">
              {t("cms.page.appearance.signupTab")}
            </TabsTrigger>
          </TabsList>
        </Tabs>
      )}
      <CmsPageAppearanceSettings
        formPrefix={showLoginSignupSwitcher ? activePrefix : formPrefix}
      />
    </StyledDrawer>
  );
}
